const defaultPushNotificationSettings = {
    deviceToken: () => null
}

export default {
    deviceToken: () => (window.pushNotifications || defaultPushNotificationSettings).deviceToken()
}
